import { FunnelSimple } from "phosphor-react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { removeOverlay } from "../../../Actions/Overlay.action";
import useIsMobile from "../../../Hooks/useIsMobile";
import { translate } from "../../../Services/translation";
import MobileRefinementsMenu from "./MobileRefinementsMenu";
import { MobileRefinementsButtonProps } from "./types/MobileRefinementsButtonProps";
import { useCurrentRefinements } from "react-instantsearch";

const MobileRefinementsButton = ({
  children,
  disabledFilters = [],
}: MobileRefinementsButtonProps) => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile("medium-large");
  const [filterMenuOpen, setFilterMenuOpen] = useState(!isMobile); // visible as default on desktop
  const { items } = useCurrentRefinements();
  const totalRefinements = items
    .filter((item) => !disabledFilters.includes(item.attribute))
    .reduce((total, item) => total + item.refinements.length, 0);

  useEffect(() => {
    if (!isMobile) {
      // Remove overlay if changed from mobile to desktop for some reason :)
      dispatch(removeOverlay("AlgoliaMobileRefinementsMenu"));

      // Set filter menu open as default in desktop
      setFilterMenuOpen(true);
    } else {
      // Set filter menu closed as default in mobile
      setFilterMenuOpen(false);
    }
  }, [isMobile]);

  return (
    <>
      <a
        className="algolia-filter-button"
        onClick={() => setFilterMenuOpen(!filterMenuOpen)}
      >
        <FunnelSimple size="16" color="#757575" className="funnel" />
        {filterMenuOpen ? (
          <>
            <span>
              {translate("filter-bar.hide-filters")} ({totalRefinements})
            </span>
          </>
        ) : (
          <>
            <span>
              {translate("filter-bar.show-filters")} ({totalRefinements})
            </span>
          </>
        )}
      </a>
      {isMobile && (
        <MobileRefinementsMenu
          isOpen={filterMenuOpen}
          onClosed={() => setFilterMenuOpen(false)}
        >
          {children}
        </MobileRefinementsMenu>
      )}
    </>
  );
};

export default MobileRefinementsButton;
